import React, { Fragment, useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

import image from "../../utils/constants/image";
import { Link } from "react-router-dom";
import { MdArrowLeft } from "react-icons/md";

const AboutUs = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  const { t } = useTranslation("home");
  return (
    <Fragment>
      <section></section>
      <section className="nove-intro py-[90px] md:py-[96px] lg:py-[115px] bg-[#fff]">
        <div className="content-wrapper">
          <h2 className="headline-border uppercase mb-[20px]">
            {t("aboutUsTitle")}
          </h2>

          <div className="row-intro flex flex-col md:flex-row md:min-h-full md:w-full lg:grid lg:grid-cols-2 md:gap-x-[30px] lg:gap-[50px] xl:gap-[96px] lg:mt-[90px] xl:mt-[109px]">
            <div className="col-2 mt-[40px] md:mt-0 lg:h-[532px] xl:h-[632px] lg:mt-0 md:w-1/3 lg:w-full">
              <div className="img-dispo h-full">
                <div className="desktop hidden lg:block relative lg:h-[532px] xl:h-[632px]">
                  <img
                    src={image.h_aboutus}
                    alt="nove team holding hands"
                    className="absolute top-0 right-0 lg:w-[300px] xl:w-[456.91px]"
                    data-aos="zoom-in-down"
                    data-aos-easing="linear"
                    data-aos-delay="300"
                  />
                  <img
                    src={image.h_aboutus2}
                    alt="nove engineer"
                    className="absolute bottom-0 left-0 lg:w-[300px] xl:w-[456.91px]"
                    data-aos="zoom-in-up"
                    data-aos-easing="linear"
                    data-aos-delay="350"
                  />
                </div>
                <div className="mobile lg:hidden flex justify-center h-full w-full">
                  <img
                    src={image.imgAbout}
                    alt="nove engineer"
                    className="object-cover object-right"
                  />
                </div>
              </div>
            </div>
            <div className="col-2 md:w-2/3 lg:w-full md:flex lg:block">
              <div className="col-2-text md:text-justify">
                <p className="mt-6">{t("aboutUsText1")}</p>
                <p className="mt-2">{t("aboutUsText2")}</p>
                <p className="mt-2">{t("aboutUsText3")}</p>


                <>
                  <Link
                    to={"a-propos"}
                    className="
                            py-[15px] flex 
                            justify-between items-center 
                            px-[20px] lg:px-[20px] 
                            xl:px-[50px] 
                            service-icon lg:py-[12px] 
                            md:px-[30px] md:py-[25px] 
                            text-blue-500 h-12 
                            lg:h-[60px] 
                            hover:bg-blue-500 hover:text-white 
                            border-2 border-blue-500 
                            hover:border-2 hover:border-transparent 
                            gap-x-6 transition 
                            duration-500 md:flex 
                            md:items-center lg:w-[50%]
                            md:justify-center w-[200px] 
                            md:w-[70%] mt-[41px]"
                  >
                    <span>{t("serviceCTA")}</span>
                    <MdArrowLeft className="icon-left" />
                  </Link>
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default AboutUs;
